import { useState } from 'react';
import {
    Button,
    Text,
    VStack,
    Box,
    Checkbox,
    HStack,
    UnorderedList,
    ListItem,
} from '@chakra-ui/react';
import { FaIcon } from '@acp/core-ui';
import { faCircleExclamation } from '@fortawesome/sharp-light-svg-icons';
import { ReportedFindingsMachineContext } from '../machine/context';

function ResolvedByThirdPartyDisclaimer() {
    const machine = ReportedFindingsMachineContext.useActorRef();
    const isSubmitting = ReportedFindingsMachineContext.useSelector(
        (state) => state.matches('submitResolution')
    );
    const [field, setField] = useState(false);

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setField(event.target.checked);
    };

    return (
        <VStack align="left" w="100%" spacing={4} mt={4}>
            <VStack w="100%" alignItems="center" gap={4} pb={10}>
                <FaIcon w={12} h={12} icon={faCircleExclamation} color="#805AD5" />
                <Text fontSize="xl" fontWeight="medium">
                    Resolving by third-party will:
                </Text>
                <UnorderedList alignItems="center" spacing={3}>
                    <ListItem fontSize="md" color="muted.700" maxW="sm">
                        Update the reported finding in the service report as compliant.
                    </ListItem>
                    <ListItem fontSize="md" color="muted.700" maxW="sm">
                        If there are remaining items in a quote, this will update
                        without the resolved items.
                    </ListItem>
                    <ListItem fontSize="md" color="muted.700" maxW="sm">
                        Documentation provided will be attached to the service report media.
                    </ListItem>
                </UnorderedList>
                <Checkbox
                    isChecked={field}
                    onChange={handleCheckboxChange}
                    mt={5}
                >
                    I understand
                </Checkbox>
                <HStack textAlign="center" mb={4} mt={2}>
                    <Button
                        colorScheme="black"
                        size="md"
                        variant="solid"
                        isLoading={isSubmitting}
                        onClick={() => machine.send({ type: 'CONFIRM' })}
                        isDisabled={!field}
                    >
                        Continue
                    </Button>
                    <Button
                        colorScheme="white"
                        size="md"
                        variant="outline"
                        onClick={() => machine.send({ type: 'BACK' })}
                    >
                        <Text>Back</Text>
                    </Button>
                </HStack>

                <Box textAlign="center" mb={4} mt={2}>
                    <Text fontSize="md" color="muted.700" maxW="md" display="inline-block">
                        <Box as="span" fontWeight="bold">Note:</Box>
                        {' '}
                        Detector inspector will not check the compliance
                        meets legislative requirements.
                        Refer to our Terms and Conditions for more information.
                    </Text>
                </Box>
            </VStack>
        </VStack>
    );
}

export { ResolvedByThirdPartyDisclaimer };
